module.exports = __webpack_public_path__ + "img/university-header-left-texture.da926b57.svg";